(($) => {
  $(document).ready(() => {
    const groups = $('.fields-group')

    $('#tipo-de-aquecimento').change(function() {
      const val = $(this).val()
      groups.hide()
      $(`#fields-${val}`).show()
    })

    let val = $('#tipo-de-aquecimento').val()
    $(`#fields-${val}`).show()

  })
})(jQuery)
